import { OccConfig } from "@spartacus/core";

const DELIVERY_MODE_ENDPOINT = 'users/${userId}/carts/${cartId}/deliverymode';

export const customDefaultOccCheckoutConfig: OccConfig = {
  backend: {
    occ: {
      endpoints: {
        // deliveryMode: `${DELIVERY_MODE_ENDPOINT}?fields=FULL`,
        // setDeliveryMode: `${DELIVERY_MODE_ENDPOINT}?fields=FULL`,
        // clearDeliveryMode: `${DELIVERY_MODE_ENDPOINT}?fields=FULL`,
        deliveryModes: `${DELIVERY_MODE_ENDPOINT}s?fields=FULL`,
      }
    }
  }
}